

import createReducer from '../createReducer'
import { Action, Nullable } from '../model'
import { ActionType } from './types'


export interface TagsReducer {
  file: Nullable<File>
}

const defaultState: TagsReducer = {
  file: null,
}

export const tagsReducer = createReducer<TagsReducer>(defaultState, {
  [ActionType.UPLOAD_CSV_TAG_FILE]: (state: Nullable<TagsReducer>, action: Action<Nullable<File>>) => ({
    ...state,
    products: action.payload,
  }),
})
